import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ProfileResponseModel } from "../../models/user/profile-response.model";
import { UserRepository } from "../../repositories/user.repository";

export class DeleteProfilePhotoUseCase implements UseCase<void, ProfileResponseModel> {
    constructor(private userRepository: UserRepository) { }
    execute(
    ): Observable<ProfileResponseModel> {
        return this.userRepository.deleteProfilePhoto();
    }
}
